// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"e6cc31ef","411":"339fc374","436":"9af27687","668":"7f9bbe36","827":"9c1202a7"}[chunkId] + ".chunk.js";
};